import React, { useContext, useEffect, useState } from "react";
import 'bootstrap-icons/font/bootstrap-icons.css';
import "./ListaMaquinas.css";
import { Button, Col, Row } from "antd";
import axios from "axios";
import * as links from "../../../../utils/links";
import { AuthContext } from "../../../../contexts/AuthContext";
import { Link, useNavigate, useLocation } from "react-router-dom";
import LoadingAction from "../../../../themes/LoadingAction/LoadingAction";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faArrowsRotate,
  faCheckCircle,
  faWifi3,
  faXmarkCircle,
} from "@fortawesome/free-solid-svg-icons";
import { AiOutlineEdit, AiOutlinePlusCircle } from "react-icons/ai";
import { useParams } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { SERVIDOR_URL } from "../../../../utils/constants";

const ListaMaquinas = (props) => {
  const { setDataUser, authInfo, setNotiMessage } = useContext<any>(AuthContext);
  const { dataUser } = authInfo;

  let navigate = useNavigate();
  const location = useLocation();

  const clienteInfo = (location.state as any);

  const token = authInfo?.dataUser?.token;

  const { id } = useParams();

  const [totalClienteMaquinas, setTotalClienteMaquinas] = useState<any>([]);
  const [totalClienteMaquinasOffline, setTotalClienteMaquinasOffline] = useState<any>([]);
  const [maquinasInfos, setMaquinasInfos] = useState<any>('');
  const [isLoading, setIsLoading] = useState<any>(true);
  const [clientes, setClientes] = useState<any>([]);

  useEffect(() => {
    dataData();
    loadClientes();

    const intervalId = setInterval(() => {
      dataData();
    }, 60000);

    return () => clearInterval(intervalId);
  }, []);

  const loadClientes = () => {
    axios
      .get(`${SERVIDOR_URL}/clientes`, {
        headers: {
          "x-access-token": token,
          "content-type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200 && Array.isArray(res.data)) {
          setClientes(res.data);
        }
      })
      .catch(() => {
        /* silencioso: apenas desabilita a abertura da máquina */
      });
  };

  const openMaquina = (post) => {
    const cliente = clientes.find(
      (item) =>
        (item?.nome ?? "").trim().toLowerCase() ===
        (post?.clienteNome ?? "").trim().toLowerCase()
    );

    if (!cliente?.id) {
      setNotiMessage({
        type: "error",
        message: "Não foi possível identificar o cliente desta máquina.",
      });
      return;
    }

    setIsLoading(true);
    axios
      .get(`${SERVIDOR_URL}/maquinas-adm?id=${cliente.id}`, {
        headers: {
          "x-access-token": token,
          "content-type": "application/json",
        },
      })
      .then((res) => {
        setIsLoading(false);
        const lista = Array.isArray(res.data) ? res.data : [];
        const maquinaInfos =
          lista.find(
            (m) =>
              (m?.nome ?? "") === (post?.nome ?? "") &&
              (m?.store_id ?? "") === (post?.store_id ?? "") &&
              (m?.descricao ?? "") === (post?.descricao ?? "")
          ) ??
          lista.find((m) => (m?.nome ?? "") === (post?.nome ?? ""));

        if (!maquinaInfos?.id) {
          setNotiMessage({
            type: "error",
            message: "Não foi possível abrir os detalhes desta máquina.",
          });
          return;
        }

        navigate(
          `${links.CLIENTES_MAQUINAS_FORNECEDOR_SEARCH}/${maquinaInfos.id}`,
          {
            state: { clienteInfo: cliente, maquinaInfos },
          }
        );
      })
      .catch(() => {
        setIsLoading(false);
        setNotiMessage({
          type: "error",
          message: "Não foi possível abrir os detalhes desta máquina.",
        });
      });
  };


  const dataData = () => {
    setIsLoading(true);
    axios
      .get(`${SERVIDOR_URL}/machines-adm`, {
        headers: {
          "x-access-token": token,
          "content-type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          setIsLoading(false);
          setTotalClienteMaquinas(res.data.maquinasOnline);
          setTotalClienteMaquinasOffline(res.data.maquinasOffline);
          setMaquinasInfos(res.data);
        } else {
          throw new Error();
        }
      })
      .catch((err) => {
        setIsLoading(false);
        if ([401, 403].includes(err.response.status)) {
          setNotiMessage({
            type: "error",
            message:
              "A sua sessão expirou, para continuar faça login novamente.",
          });
          if(dataUser.key === 'ADMIN'){
            navigate(links.ADMIN_SIGNIN)
            setDataUser(null);
          }else{
            navigate(links.SIGNIN)
            setDataUser(null);
          }
        }
      });
  };

  return (
    <div className="Cliente_Maquinas_container px-page">
      {isLoading && <LoadingAction />}
      {dataUser?.warningMsg && (
        <div className="WarningMsgSpan">
          <span>{dataUser.warningMsg}</span>
        </div>
      )}
      <div className="px-page-header">
        <h1 className="px-page-title">Máquinas</h1>
        <Link className="px-back-btn" to={links.DASHBOARD_CLIENTES}>
          VOLTAR
        </Link>
      </div>

      <div className="px-toolbar" style={{ marginBottom: 18 }}>
        <Button className="Dashboard_addbtn" onClick={() => dataData()}>
          <FontAwesomeIcon
            icon={faArrowsRotate}
            style={{ marginRight: "6px" }}
          />
          Atualizar
        </Button>
      </div>

      <div className="px-stat-grid">
        <div className="px-stat-card">
          <div>
            <p className="px-stat-label">Total</p>
            <p className="px-stat-value">{maquinasInfos?.total ?? 0}</p>
          </div>
        </div>
        <div className="px-stat-card">
          <div>
            <p className="px-stat-label">Online</p>
            <p className="px-stat-value px-stat-online">
              {maquinasInfos?.online ?? 0}
            </p>
          </div>
        </div>
        <div className="px-stat-card">
          <div>
            <p className="px-stat-label">Offline</p>
            <p className="px-stat-value px-stat-offline">
              {maquinasInfos?.offline ?? 0}
            </p>
          </div>
        </div>
      </div>

      <div className="px-section-title">Máquinas Online</div>
      <Row>
        {totalClienteMaquinas.map((post, index) => (
          <Col key={`on-${index}`} xs={24} md={24} lg={8} xl={8} className="Cliente_Maquinas_col">
            <div
              className="Cliente_Maquinas_clickable"
              onClick={() => openMaquina(post)}
            >
              <div className="maquina">

                <div className="maquina-info">
                  {(() => {
                    switch (post.status) {
                      case "PAGAMENTO_RECENTE":
                        return (
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <FontAwesomeIcon
                            icon={faCheckCircle}
                            color={"blue"}
                            className="logout-icon fa-3x"
                          />
                          {
                            post.nivelDeSinal ?
                            post.nivelDeSinal <= 30 ? 
                            <OverlayTrigger
                              key={post.id}
                              placement="top"
                              overlay={
                                <Tooltip id={`tooltip-top-${post.id}`}>
                                    {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                </Tooltip>
                              }>
                                <i className="bi bi-reception-1" style={{ fontSize: '42px', color: 'blue' }}></i>
                            </OverlayTrigger>
                            :
                            post?.nivelDeSinal <= 60 ?
                            <OverlayTrigger
                              key={post.id}
                              placement="top"
                              overlay={
                                <Tooltip id={`tooltip-top-${post.id}`}>
                                  {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                </Tooltip>
                              }>
                                <i className="bi bi-reception-2" style={{ fontSize: '42px', color: 'blue' }}></i>
                            </OverlayTrigger>
                            :
                            post?.nivelDeSinal <= 70 ?
                            <OverlayTrigger
                              key={post.id}
                              placement="top"
                              overlay={
                                <Tooltip id={`tooltip-top-${post.id}`}>
                                  {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                </Tooltip>
                              }>
                                <i className="bi bi-reception-3" style={{ fontSize: '42px', color: 'blue' }}></i>
                            </OverlayTrigger>
                            :
                            <OverlayTrigger
                              key={post.id}
                              placement="top"
                              overlay={
                                <Tooltip id={`tooltip-top-${post.id}`}>
                                  {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                </Tooltip>
                              }>
                                <i className="bi bi-reception-4" style={{ fontSize: '42px', color: 'blue' }}></i>
                            </OverlayTrigger>
                            :
                            <OverlayTrigger
                              key={post.id}
                              placement="top"
                              overlay={
                                <Tooltip id={`tooltip-top-${post.id}`}>
                                  {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                </Tooltip>
                              }>
                                <i className="bi bi-reception-0" style={{ fontSize: '42px', color: 'transparent'}}></i>
                            </OverlayTrigger>
                          }
                        </div>
                        );
                      case "online":
                        return (
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              color={"green"}
                              className="logout-icon fa-3x"
                            />
                            {
                              post.nivelDeSinal ?
                              post.nivelDeSinal <= 30 ? 
                              <OverlayTrigger
                                key={post.id}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-top-${post.id}`}>
                                    {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                  </Tooltip>
                                }>
                                <i className="bi bi-reception-1" style={{ fontSize: '42px', color: 'blue' }}></i>
                              </OverlayTrigger>
                              :
                              post?.nivelDeSinal <= 60 ?
                              <OverlayTrigger
                                key={post.id}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-top-${post.id}`}>
                                    {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                  </Tooltip>
                                }>
                                  <i className="bi bi-reception-2" style={{ fontSize: '42px', color: 'blue' }}></i>
                              </OverlayTrigger>
                              :
                              post?.nivelDeSinal <= 70 ?
                              <OverlayTrigger
                                key={post.id}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-top-${post.id}`}>
                                    {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                  </Tooltip>
                                }>
                                <i className="bi bi-reception-3" style={{ fontSize: '42px', color: 'blue' }}></i>
                              </OverlayTrigger>
                              :
                              <OverlayTrigger
                                key={post.id}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-top-${post.id}`}>
                                    {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                  </Tooltip>
                                }>
                                <i className="bi bi-reception-4" style={{ fontSize: '42px', color: 'blue' }}></i>
                              </OverlayTrigger>
                              :
                              <OverlayTrigger
                                key={post.id}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-top-${post.id}`}>
                                    {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                  </Tooltip>
                                }>
                                  <i className="bi bi-reception-0" style={{ fontSize: '42px', color: 'transparent'}}></i>
                              </OverlayTrigger>
                            }
                          </div>
                        );
                      case "offline":
                        return (
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <FontAwesomeIcon
                              icon={faXmarkCircle}
                              color={"red"}
                              className="logout-icon fa-3x"
                            />
                            {
                              <OverlayTrigger
                                key={post.id}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-top-${post.id}`}>
                                    {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                  </Tooltip>
                                }>
                                  <i className="bi bi-reception-0" style={{ fontSize: '42px', color: 'transparent'}}></i>
                              </OverlayTrigger>
                            }
                          </div>
                        );
                      default:
                        return null;
                    }
                  })()}

                  <h2>{post.nome}</h2>
                  <h6 style={{ fontWeight: "300" }}>
                    {post.status} - {post.descricao}
                  </h6>
                  <h6 style={{ fontWeight: "300" }}>MP: {post.store_id}</h6>
                  <h6 style={{ fontWeight: "300" }}>PAG: {post.maquininha_serial}</h6>
                  <h6 style={{ fontWeight: "300" }}>Cliente: {post.clienteNome}</h6>
                </div>
              </div>
            </div>
          </Col>
        ))}
      </Row>
      <div className="px-section-title">Máquinas Offline</div>
      <Row>
        {totalClienteMaquinasOffline.map((post, index) => (
          <Col key={`off-${index}`} xs={24} md={24} lg={8} xl={8} className="Cliente_Maquinas_col">
            <div
              className="Cliente_Maquinas_clickable"
              onClick={() => openMaquina(post)}
            >
              <div className="maquina">

                <div className="maquina-info">
                  {(() => {
                    switch (post.status) {
                      case "online":
                        return (
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              color={"green"}
                              className="logout-icon fa-3x"
                            />
                            {
                              post.nivelDeSinal ?
                              post.nivelDeSinal <= 30 ? 
                              <OverlayTrigger
                                key={post.id}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-top-${post.id}`}>
                                    {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                  </Tooltip>
                                }>
                                <i className="bi bi-reception-1" style={{ fontSize: '42px', color: 'blue' }}></i>
                              </OverlayTrigger>
                              :
                              post?.nivelDeSinal <= 60 ?
                              <OverlayTrigger
                                key={post.id}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-top-${post.id}`}>
                                    {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                  </Tooltip>
                                }>
                                  <i className="bi bi-reception-2" style={{ fontSize: '42px', color: 'blue' }}></i>
                              </OverlayTrigger>
                              :
                              post?.nivelDeSinal <= 70 ?
                              <OverlayTrigger
                                key={post.id}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-top-${post.id}`}>
                                    {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                  </Tooltip>
                                }>
                                <i className="bi bi-reception-3" style={{ fontSize: '42px', color: 'blue' }}></i>
                              </OverlayTrigger>
                              :
                              <OverlayTrigger
                                key={post.id}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-top-${post.id}`}>
                                    {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                  </Tooltip>
                                }>
                                <i className="bi bi-reception-4" style={{ fontSize: '42px', color: 'blue' }}></i>
                              </OverlayTrigger>
                              :
                              <OverlayTrigger
                                key={post.id}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-top-${post.id}`}>
                                    {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                  </Tooltip>
                                }>
                                  <i className="bi bi-reception-0" style={{ fontSize: '42px', color: 'transparent'}}></i>
                              </OverlayTrigger>
                            }
                          </div>
                        );
                      case "offline":
                        return (
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <FontAwesomeIcon
                              icon={faXmarkCircle}
                              color={"red"}
                              className="logout-icon fa-3x"
                            />
                            {
                              <OverlayTrigger
                                key={post.id}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-top-${post.id}`}>
                                    {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                  </Tooltip>

                                }>
                                  <i className="bi bi-reception-0" style={{ fontSize: '42px', color: 'transparent'}}></i>
                              </OverlayTrigger>
                            }
                          </div>
                        );
                      default:
                        return null;
                    }
                  })()}

                  <h2>{post.nome}</h2>
                  <h6 style={{ fontWeight: "300" }}>
                    {post.status} - {post.descricao}
                  </h6>
                  <h6 style={{ fontWeight: "300" }}>MP: {post.store_id}</h6>
                  <h6 style={{ fontWeight: "300" }}>PAG: {post.maquininha_serial}</h6>
                  <h6 style={{ fontWeight: "300" }}>Cliente: {post.clienteNome}</h6>
                </div>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default ListaMaquinas;
